import { notificationFrequencyTypes } from 'constants/enums';
import { useCallback, useEffect, useState } from 'react';
import { useStores } from 'stores';
import styles from '../../MySubscriptions.module.scss';
import { observer } from 'mobx-react';
import { RadioGroup } from 'uiKit/atoms/Group/RadioGroup/RadioGroup';
import { Radio } from 'uiKit/atoms/Radio/Radio';
import { FormControlLabel } from 'uiKit/atoms/FormControlLabel/FormControlLabel';

const SubscriptionNotifications: React.FC = () => {
    const {
        subscriptionStore: { getNotificationFriquency, updateNotificationFriquency }
      } = useStores();
    
      const [notificationFrequency, changeNotificationFrequency] = useState([]);
    
      useEffect(() => {
        getNotificationFriquency().then(res => {
          changeNotificationFrequency(res.notificationsFrequency);
        });
      }, []);

      const handleChangeNotificationFrequency = useCallback((el: any, value : string) => {
        updateNotificationFriquency({ notificationsFrequency: value });
        changeNotificationFrequency(el.target.value);
      }, [updateNotificationFriquency, changeNotificationFrequency]);
    
    return (
      <div className={styles.bns3_myNotifications}>
          <div className={styles.bns3_notificationsTitle}>
          <p className={styles.titleWrapper}>notifications</p>
          </div>
          <div className={styles.bns3_notificationsList}>
          <div>
            <p className={styles.titleMessage}>
              How often would you like to receive email notifications about new lots in your subscriptions?
            </p>
            <RadioGroup
              value={notificationFrequency}
              onChange={handleChangeNotificationFrequency}>
              {notificationFrequencyTypes.map((item) => (
                <FormControlLabel
                  key={item.value}
                  value={item.value}
                  control={<Radio />}
                  label={item.label}
                />
              ))}
            </RadioGroup>
          </div>
          
          </div>
      </div>
  );
};

export default observer(SubscriptionNotifications);
